export default [
  {
    path: 'profile',
    meta: { auth: true, isSeoBlockHidden: true, layout: 'profile' },
    redirect: () => ({ name: 'balance' }),
    component: () => import('src/pages/profile/new/Profile.vue'),
    children: [
      {
        path: '',
        name: 'profile',
        meta: { auth: true, isSeoBlockHidden: true },
        component: () => import('src/pages/profile/Information.vue'),
      },
      {
        path: 'balance',
        name: 'balance',
        meta: { auth: true, isSeoBlockHidden: true },
        component: () => import('src/pages/profile/Balance.vue'),
      },
      {
        path: 'bonuses',
        name: 'bonuses',
        meta: { auth: true, isSeoBlockHidden: true },
        component: () => import('src/pages/profile/BonusesView.vue'),
      },
      {
        path: 'messages',
        name: 'messages',
        meta: { auth: true, isSeoBlockHidden: true },
        component: () => import('src/pages/profile/MessagesView.vue'),
      },
      {
        path: 'account',
        name: 'account',
        meta: { auth: true, isSeoBlockHidden: true, isFooterHidden: true },
        component: () => import('src/pages/profile/new/ProfileAccount.vue'),
      },
    ],
  },
]
